// src/pages/CustomerManagement/AddInvoice.tsx

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import styles from "./AddInvoice.module.scss";

const AddInvoice: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [invoice, setInvoice] = useState("");
  const [userId, setUserId] = useState<number | "">("");
  const [appTime, setAppTime] = useState("");
  const [appointment, setAppointment] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!invoice || !fullName || !email) {
      setError(t("addInvoice.form.requiredFields"));
      return;
    }

    try {
      const payload = {
        invoice,
        user_id: userId === "" ? null : userId,
        app_time: appTime,
        appointment,
        full_name: fullName,
        email,
      };

      const res = await api.post("/add_invoice", payload);

      if (res.status === 200) {
        setSuccess(t("addInvoice.form.success"));
        // 清空表单
        setInvoice("");
        setUserId("");
        setAppTime("");
        setAppointment(false);
        setFullName("");
        setEmail("");
        // 可选择导航回客户管理页面
        // navigate("/customer_management");
      }
    } catch (err: any) {
      console.error("Failed to add invoice:", err);
      setError(err.response?.data?.error || t("addInvoice.form.error"));
    }
  };

  return (
    <div className={styles.addInvoiceContainer}>
      <div className={styles.addInvoiceBox}>
        <h1>{t("addInvoice.title")}</h1>
        <form onSubmit={handleSubmit} className={styles.addInvoiceForm}>
          <div className={styles.formGroup}>
            <label htmlFor="invoice">{t("addInvoice.form.invoice")} *</label>
            <input
              type="text"
              id="invoice"
              value={invoice}
              onChange={(e) => setInvoice(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="userId">{t("addInvoice.form.userId")}</label>
            <input
              type="number"
              id="userId"
              value={userId}
              onChange={(e) =>
                setUserId(e.target.value === "" ? "" : parseInt(e.target.value))
              }
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="appTime">{t("addInvoice.form.appTime")}</label>
            <input
              type="text"
              id="appTime"
              value={appTime}
              onChange={(e) => setAppTime(e.target.value)}
            />
          </div>

          <div className={styles.formGroupCheckbox}>
            <input
              type="checkbox"
              id="appointment"
              checked={appointment}
              onChange={(e) => setAppointment(e.target.checked)}
            />
            <label htmlFor="appointment">
              {t("addInvoice.form.appointment")}
            </label>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="fullName">{t("addInvoice.form.fullName")} *</label>
            <input
              type="text"
              id="fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="email">{t("addInvoice.form.email")} *</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}
          {success && <div className={styles.success}>{success}</div>}

          <div className={styles.formActions}>
            <button type="submit" className={styles.submitButton}>
              {t("addInvoice.form.submit")}
            </button>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={() => navigate("/customer_management")}
            >
              {t("addInvoice.form.cancel")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddInvoice;
